<template>
  <div class="myask">
    <van-tabs v-model="active" title-active-color="#3A3A3A" color="#3A3A3A" @click="onClick" sticky>
      <van-tab title="提问">
        <van-list
        v-model="loading"
        :finished="finished"
        finished-text="已加载全部"
        :immediate-check="false"
        @load="onLoad"
        >
        <div slot="loading" class="list-loading">
          <img :src="img.loading" />
        </div>
        <div class="list-box" v-for="item in qlist" :key="'qlist_' + item.id">
          <router-link :to="{name: 'LexusAskShow', params: {id: item.id}}" class="c-black">
            <div class="listitle ellipsis-2">
              <img class="answtag" :src="img.questionicon">
              {{ item.question }}
            </div>
            <div class="f-15">
              {{ item.content }}
            </div>
            <div class="pic-box" v-if="item.image">
              <img class="pic_thumb" fit="cover" :src="item.image">
            </div>
          </router-link>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <span class="sourtime">暂无回答</span>
            </van-col>
            <van-col class="bintright" span="10" :data-code="item.id" @click="delQuestion">
              <span class="sourtime">删除</span>
            </van-col>
          </van-row>
        </div>
      </van-list>
      <div v-if="qlist.length==0" class="nodata">暂无数据</div>
    </van-tab>
    <van-tab title="回答">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      :immediate-check="false"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div class="list-box" v-for="item in alist" :key="'alist_' + item.answer.id">
        <router-link :to="{name: 'LexusAskShowAnswer', params: {id: item.answer.id}}" class="c-black">
          <div class="listitle ellipsis-2">
            <img class="answtag" :src="img.questionicon">
            {{ item.question }}
          </div>
          <div class="f-15 ellipsis-4" v-if="item.answer.content">
            <img class="answtag" :src="img.answericon">
            {{ item.answer.content.text }}
          </div>
          <div class="pic-box" v-if="item.answer.content&&item.answer.content.img">
            <img class="pic_thumb" fit="cover" :src="item.answer.content.img">
          </div>
        </router-link>
        <div class="bintright" :data-code="item.answer.id" @click="delAsk">
          <span class="sourtime">删除</span>
        </div>
      </div>
    </van-list>
    <div v-if="alist.length==0" class="nodata">暂无数据</div>
  </van-tab>
  <van-tab title="草稿">
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    :immediate-check="false"
    @load="onLoad"
    >
    <div class="list-box" v-for="item in dlist" :key="'dlist_' + item.id">
      <div v-if="item.type.id==1">
        <div class="listitle ellipsis-2">
          <img class="answtag" :src="img.questionicon">
          {{ item.question }}
        </div>
        <div class="f-15">
          {{ item.content }}
        </div>
        <div class="pic-box" v-if="item.image">
          <img class="pic_thumb" fit="cover" :src="item.image">
        </div>
        <div class="bintright" :data-code="item.id" @click="delQuestion">
          <span class="sourtime">删除</span>
        </div>
      </div>
      <div v-else-if="item.type.id==3">
        <div class="listitle ellipsis-2">
          {{ item.question }}
        </div>
        <div class="f-15 ellipsis-4">
          <img class="answtag" :src="img.answericon">
          {{ item.answer.content.text }}
        </div>
        <div class="pic-box" v-if="item.answer.content.img">
          <img class="pic_thumb" fit="cover" :src="item.answer.content.img">
        </div>

        <div class="bintright" :data-code="item.id" @click="delQuestion">
          <span class="sourtime">删除</span>
        </div>
      </div>
    </div>
  </van-list>
  <div v-if="dlist.length==0" class="nodata">暂无数据</div>
</van-tab>
</van-tabs>
</div>
</template>
<script>
  import common from '../../../api/common';
  import list from '../../../api/member/myask';
  import { mapState } from 'vuex';
  import { Tab, Tabs, List, Row, Col, Button, Tag, Grid, GridItem, Image, Icon} from 'vant';
  
  export default {
    data(){
      return{
        active: 0,
        qlist: [],
        alist:[],
        dlist:[],
        page:1,
        channel_id:5,
        user_id:'',
        loading: false,
        finished: false,
        num:10,
        img: {
         parise: require('../../../assets/img/parise.png'),
         parise_have: require('../../../assets/img/parise_have.png'),
         comment: require('../../../assets/img/comment.png'),
         avatar: require('../../../assets/img/lexus/default.png'),
         question: require('../../../assets/img/question.png'),
         answer: require('../../../assets/img/answers.png'),
         answericon: require('../../../assets/img/lexus/answericon.png'),
         questionicon: require('../../../assets/img/lexus/questionicon.png'),
       }
     }
   },
   computed: {
    ...mapState({
      user: state => state.param.user,
      source: state => state.param.source
    })
  },
  created () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      } else {
        this.$appService.needLogin()
      }
    })
    let params={
      channel_id:5,
      page:this.page,
    }
    this.getAsk(params)
    var paramsd={
      event_code:'我的问答',
      event_id: '',
      title: '',
      value: '',
      path: '/Lexus/My/MyAsk.vue',
      user_id: this.user ? this.user.id : 0,
      source: this.source
    }
    common.BurialPoint(paramsd).then(res => {
      if(res.data.state==1){
      }
    })
    var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
  },
  methods: {
    onClick(name){
      if(name==0){
        this.qlist=[]
        this.page=1
        let params={
         channel_id:5,
         page:1
       }
       this.getAsk(params)
     }else if(name==1){
      this.alist=[]
      this.page=1
      let params={
        channel_id:5,
        page:1
      }
      this.getAnswer(params)
    }else{
      this.dlist=[]
      this.page=1
      let params={
        channel_id:5,
        page:1
      }
      this.getDraft(params)
    }
  },
  getAsk(params){
    list.getAsk(params).then(res => {
      if(res.data.state == 1) {
        let qlist=this.qlist
        let newlist=res.data.data.data
        if(qlist.length==0){
          this.qlist = res.data.data.data
        }else{
          this.num=newlist.length
          this.qlist = this.qlist.concat(newlist)
        }
      }
    })
  },
  getAnswer(params){
    list.getAnswer(params).then(res => {
      if(res.data.state == 1) {
        let alist=this.alist
        let newlist=res.data.data.data
        if(alist.length==0){
          this.alist = res.data.data.data
        }else{
          this.num=newlist.length
          this.alist = this.alist.concat(newlist)
        }
      }
    })
  },
  getDraft(params){
    list.getDraft(params).then(res => {
      if(res.data.state == 1) {
        let dlist=this.dlist
        let newlist=res.data.data.data
        if(dlist.length==0){
          this.dlist = res.data.data.data
        }else{
          this.num=newlist.length
          this.dlist = this.dlist.concat(newlist)
        }
      }
    })
  },
  delAsk(e){
    let id=e.currentTarget.dataset.code
    this.$dialog.confirm({
      message: '确定要删除吗？'
    }).then(() => {
      list.delAsk(id).then(res => {
        if(res.data.state == 1) {
          let list=this.alist
          for (var i=0;i<list.length;i++) {
            if(list[i].answer.id==id){
             list.splice(i, 1)
           }
         }
         this.alist=list
         this.$toast.success('删除成功');
       }
     })
    }).catch(() => {
    });
  },
  delQuestion(e){
    let id=e.currentTarget.dataset.code
    this.$dialog.confirm({
      message: '确定要删除吗？'
    }).then(() => {
      list.delQuestion(id).then(res => {
        if(res.data.state == 1) {
          let list=this.qlist
          for (var i=0;i<list.length;i++) {
            if(list[i].id==id){
             list.splice(i, 1)
           }
         }
         this.qlist=list
         this.$toast.success('删除成功');
       }
     })

    }).catch(() => {
    });
  },
  delDefault(e){
    let id=e.currentTarget.dataset.code
    this.$dialog.confirm({
      message: '确定要删除吗？'
    }).then(() => {
      list.delDefault(id).then(res => {
        if(res.data.state == 1) {
          let list=this.dlist
          for (var i=0;i<list.length;i++) {
            if(list[i].id==id){
             list.splice(i, 1)
           }
         }
         this.dlist=list
         this.$toast.success('删除成功');
       }
     })
    }).catch(() => {
    });
  },
  onLoad() {
    setTimeout(() => {
      let num=this.num
      if (num <10) {
        this.finished = true
        this.loading = false
      }else{
        this.page=this.page+1
        let params={
          channel_id:5,
          page:this.page
        }
        if(this.active==0){
          this.getAsk(params)
        }else if(this.active==1){
          this.getAnswer(params)
        }else{
          this.getDraft(params)
        }
        this.loading = false
      }
    }, 500);
  },
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [Grid.name]: Grid,
  [GridItem.name]: GridItem,
  [List.name]: List,
  [Button.name]: Button,
  [Tabs.name]: Tabs,
  [Tab.name]: Tab,
  [Tag.name]: Tag,
  [Image.name]:Image,
  [Icon.name]:Icon
}
}
</script>

<style lang="scss">
.myask{
  .list-box{
    padding: 15px;
    border-bottom: 1px solid #f8f8f8;
    a {
      padding: 0;
      color: #3A3A3A;
    }
    .picone{
      width:100%;
      height:105px;
      border-radius:5px;
    }
    .listitle{
      font-size: 15px;
      font-weight:bold;
      line-height: 1.8;
      letter-spacing: 1.4px;
    }
    .sourtime{
      font-size:14px;
      color:rgba(154,154,154,1);
    }
    .bintright{
      text-align:right;
      .binbox{
        margin-left:20px;
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right:8px;
      }
    }
    .pic-box {
      padding: 10px 0 10px 0 !important;
      height: 210px !important;
      .pic_thumb{
        border-radius: 1.5px;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin-top: 10px;
      }
    }
    .answtag{
      width: 15px;
      height: 15px;
      margin-right: 10px;
      vertical-align: middle;
    }
    .f-15{
      margin-top: 10px;
    }
  }
}
</style>
